import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { editorSelectors } from 'store/features/editor/selectors'
import { buildTextStylesFromLibraryFonts, ITextStyle } from './mock-text-styles'
import * as Styled from './styled'

interface ITextStylesProps {
  onSelect: (style: ITextStyle) => void
}

export const TextStyles = ({ onSelect }: ITextStylesProps) => {
  const libraryFonts = useSelector(editorSelectors.libraryFonts)
  const textStyles = useMemo(
    () => buildTextStylesFromLibraryFonts(libraryFonts),
    [libraryFonts]
  )

  const handleClick = useCallback(
    (style: ITextStyle) => () => onSelect(style),
    [onSelect]
  )

  return (
    <Styled.Grid>
      {textStyles.map(style => (
        <Styled.StyleCard key={style.id} onClick={handleClick(style)}>
          <Styled.Thumbnail
            src={style.previewPath}
            alt={`Text style ${style.id}`}
          />
        </Styled.StyleCard>
      ))}
    </Styled.Grid>
  )
}
